(function (angular) {
  "use strict";

  angular.module('myApp').component('menuInformationEdit', {
    templateUrl: '/menu/views/menuInformationEdit.tpl.html',
    controller: [
      '$scope', 'menuService', 'aimEdit', 'languageService','FileUploader',
      function ($scope, menuService, aimEdit, languageService , FileUploader) {

        $scope.aim = new aimEdit();
        $scope.aim.service = menuService;
        $scope.aim.listRoute = 'menu';
        $scope.aim.load();

        $scope.tempUploadUrl = tempUploads;
        $scope.profileImageUploadUrl = memberProfileUpload;
        $scope.aim.result.errors = {};
        $scope.profileUploader = new FileUploader({ url: "image-upload-filesize" });
        $scope.profileUploader.onAfterAddingFile = function (fileItem) { fileItem.uploader.queue[0].upload(); };
        $scope.profileUploader.onProgressItem = function (fileItem, progress) { };
        $scope.profileUploader.onCompleteItem = function (fileItem, response, status, headers) {
          if (response.success) {
            $scope.aim.dto.imageUrl = response.data.filePath + response.data.fileName;
          } else {
            $scope.aim.result.errors.imageUrl = response.message;
            $scope.aim.dto.imageUrl = '';
          }
          if (this._directives.select[0].element[0].value !== undefined)
            this._directives.select[0].element[0].value = '';
          fileItem.uploader.clearQueue();
        };

        menuService.getAllMenu().then(function (resp) {
          $scope.categories = resp.data;
        });

        languageService.getLanguages().then(function (resp) {
          $scope.languages = resp.data;
        });
      }
    ]
  });

}(window.angular));
